// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"Embed__sidebar___3voJd","caret":"Embed__caret___3WzVJ","today":"Embed__today___3ulOD","firstRow":"Embed__firstRow___2rIuB","buttonRow":"Embed__buttonRow___7BbtT","sidebarLabel":"Embed__sidebarLabel___3ba_9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormActivity/Components/Embed.scss
// module id = 1176
// module chunks = 1